export function getSpecialties(state) {
  return state;
}

export function hasSpecialties(state) {
  return state && state.length > 0;
}
